import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function AddTemplate(){
    const [temp, setTemp] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const quillRef = useRef(null);
    const [tempData,settempData]=useState({
        "type":'',
        "template":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });

    const handleChange = (event) => {
        settempData({
            ...tempData,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('type',tempData.type);
        _formData.append('template',tempData.template);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        try{
            axios.post(baseUrl+'template-create/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:3000,
                        showConfirmButton: false
                    });
                    setTimeout(() => {
                    window.location.href = ('/add-template/');
                    }, 3000);
               }
            });
            }catch(error){
                console.log(error);
            }
        };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (temp.length > 0) {
        setRows(temp);
      }
  }, [temp]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}template-create/`)
      .then(response => {
        setTemp(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

    const handleDelete = (temp_id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-template/'+temp_id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/add-template/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
    { field: 'id', headerName: 'Id', width: 20 },
    { field: 'type', headerName: 'Type', width: 120 },
    { field: 'template', headerName: 'Template', width: 500 },
    { field: 'addedby', headerName: 'Added By', width: 200},
    { field: 'edit', headerName: 'Edit',
        renderCell: (params) => (
          <Link to={`/edit-template/${params.row.id}/`} target="_blank" className="btn btn-warning">
            Edit
          </Link>
      ),
      width: 120 },
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },

  ];
  const handleLoad = (quill) => {
    quillRef.current = quill;
  };
    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Add Template</h4>
                    <div className='card-body'>
                        <form>
                          <div className="mb-3">
                            <label htmlFor="type" className="form-label">Type</label>
                            <input type="text" className="form-control" name="type" value={tempData.type}
                            onChange={handleChange} id="type" />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="type" className="form-label">Template</label>
                            <ReactQuill
                            style={{ height: "200px" }}
                            className="my-quill"
                            tabIndex="0"
                            onLoad={handleLoad}
                            name="template"
                            id="result"
                            value={tempData.template}
                            onChange={(value) => handleChange({ target: { name: 'template', value } })}
                            modules={{
                              toolbar: [
                                [{ header: [1, 2, false] }],
                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                [
                                  { list: 'ordered' },
                                  { list: 'bullet' },
                                  { indent: '-1' },
                                  { indent: '+1' },
                                ],
                                ['link', 'image'],
                                ['table'],
                                ['clean'],
                              ],
                            }}
                          />
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mt-5">
                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                          </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>

        </section>

)
}

export default AddTemplate;